import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const PUBLIC_PROFILE_ACTION: string = "PublicProfileActionChannel";

export interface IPublicProfileActionService {
  savePublicProfile(
    profileName: string,
    layout: string,
    overWriteExisting: boolean,
  ): Promise<CubiqTS.ErrorsImpl | null>;

  /**
   * Switch the profile for the current user to the specified profile. This should result in the
   * user session being immediately terminated on success
   * @param profile
   * @returns
   */
  switchProfile(profile: CubiqTS.PlatformProfileImpl): Promise<void>;
}
